import Vue from 'vue'

export function commaFormat(value) {
  if (!value) return '0'
  const strNumber = value.toString().replace(/[^\d\\-]/g, '')
  const plainNumber = Number(strNumber).toString()
  return plainNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
Vue.filter('commaFormat', commaFormat)

export function commaRemove(value) {
  if (!value) {
    return
  } else if (typeof value === 'number') {
    return value
  }
  return Number(value.replace(/[^\d]/g, ''))
}

Vue.filter('commaRemove', commaRemove)

Vue.filter('won', function (value) {
  if (!value) return '0'
  return value.toString() + '원'
})
